module.exports = __webpack_public_path__ + "static/media/scale-mail.cb5ff7d5.svg";